import axios from "axios";
import authInterceptor from "./interceptors/authInterceptor";


const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`
})

api.interceptors.request.use(authInterceptor)

export default api;